import { useSelector } from "react-redux";
import {
  getIsPersonalizationFetching,
  getPersonalizationColors,
  getServerPersonalizationData,
  getPersonalizationStateChanged,
  getPersonalizationHasError,
  getPersonalizationDataHomePageTitle,
  getPersonalizationDataHomePageInfo,
  getServerPersonalizationMaxDecimalCount,
  getMergedPersonalization,
  getMergedAppSettingData,
  getTemplatesOnModulesCount,
  getAppVersion,
} from "./selectors";

export const useIsPersonalizationFetching = () =>
  useSelector((state) => getIsPersonalizationFetching(state));

export const usePersonalizationStateChanged = () =>
  useSelector((state) => getPersonalizationStateChanged(state));

export const useHomePageInfo = (): string =>
  useSelector((state) => getPersonalizationDataHomePageInfo(state));

export const useHomePageTitle = (): string =>
  useSelector((state) => getPersonalizationDataHomePageTitle(state));

export const useServerPersonalizationData = () =>
  useSelector((state) => getServerPersonalizationData(state));

export const useMergedPersonalizationData = () =>
  useSelector((state) => getMergedPersonalization(state));

export const usePersonalizationColors = () =>
  useSelector((state) => getPersonalizationColors(state));

export const usePersonalizationHasError = () =>
  useSelector(getPersonalizationHasError);

export const useMergedAppSettingData = () =>
  useSelector((state) => getMergedAppSettingData(state));

export const useMaxDecimalCount = (): number =>
  useSelector(getServerPersonalizationMaxDecimalCount);

export const useTemplatesOnModulesCount = () =>
  useSelector(getTemplatesOnModulesCount);

export const useAppVersion = () => useSelector(getAppVersion);
